!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = e || self).rematchLogger = t();
}(this, function () {
  "use strict";

  function l(e, t) {
    if (null == e) return {};

    var n,
        r,
        o = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          u = Object.keys(e);

      for (r = 0; r < u.length; r++) {
        n = u[r], 0 <= t.indexOf(n) || (o[n] = e[n]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var u = Object.getOwnPropertySymbols(e);

      for (r = 0; r < u.length; r++) {
        n = u[r], 0 <= t.indexOf(n) || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }

    return o;
  }

  return function () {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
        t = {
      log: console.log,
      timestamp: !0,
      payload: !0
    },
        u = Object.assign({}, t, e);

    function i(e) {
      var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : 2;
      return e.toString().length < t ? "0".repeat(t - e.toString().length) + e : e;
    }

    return {
      middleware: function middleware(e) {
        return function (o) {
          return function (e) {
            var t = e.type,
                n = l(e, ["type"]),
                r = [];
            return u.timestamp && r.push(function (e) {
              return i(e.getHours()) + ":" + i(e.getMinutes()) + ":" + i(e.getSeconds()) + "." + i(e.getMilliseconds(), 3);
            }(new Date())), r.push(t), u.payload && r.push(n), u.log.apply(u, r), o(e);
          };
        };
      }
    };
  };
});